/**
 * Represents the possible lot polygons to support on top of Community Interactive Site Plans.
 */
export default class LotPolygonType {

  /**
   * Selected option for lots that received a click/tap.
   */
  static get Selected() {  
    return this.getInstance('selected');
  }

  /**
   * Active option for lots that represents an area where there are plans or specs
   * matching the user search criteria.
   */
  static get Active() {
    return this.getInstance('active');
  }

  /**
   * Hovered option for lots that needs to be highlighted based on hover interaction.
   */
  static get Hovered() {
    return this.getInstance('hovered');
  }

  /**
   * Inactive option for those lots that don't have any plan or spec matching the user
   * search criteria. Inactive lots should have the base map color.
   */
  static get Inactive() {
    return this.getInstance('inactive');
  }

  static fromKey(key) {
    const map = {
      active: LotPolygonType.Active,
      default: LotPolygonType.Selected,
      hovered: LotPolygonType.Hovered,
      empty: LotPolygonType.Inactive,
    };
    return map[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new LotPolygonType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(LotPolygonType, 'instances', { value: {} });
